import {get, post, upload, download, postAudio, downloadGet} from './http'
import { userInfo, globalConfig } from '../util/globalStore'
import {changeSeoMeta, getLanguage} from '../util'
import {getCountryInfoList} from '../countryList'

export default {}

export const getD = (url, data, showError) => get(url, data, showError)
export const postD = (url, data, showError) => post(url, data, showError)
export const uploadD = (url, data, fileName, file, showError) => upload(url, data, fileName, file, showError)
export const downloadD = (url, data, fileName, showError) => download(url, data, fileName, showError)


//退出账号
export const logout = (c) => {
	const user = userInfo()
	user.logout()
	c()
}

//获取最新用户信息
export const getUserInfo = () => post("/home/user", {
	uuid: globalConfig().tempUserID
}, false).then(res => {
	const user = userInfo()
	user.$patch(res.data)
	user.$patch((state) => {
		state.id = res.data.user_id
		if ([true, 1, '1', 'true'].includes(res.data.sub_pop_status)) {
			state.sub_pop_api_approved_user_id = res.data.user_id
		}
	})
	globalConfig().lastLoginUserID = user.id
	//修改配色
	document.documentElement.style.setProperty('--main-color', user.themeColor);
	return res.data
}).catch(err => {
	console.log("updateUser error", err)
	throw err
})

//访问页面埋点
export const pageVisitLog = (url) => post("/login/visitLog", {
	uuid: globalConfig().tempUserID,
	page_url: url
}, false).then(res => {
	return res.data
}).catch(err => {
	console.log("pageView error", err)
	throw err
})

//更新用户信息
export const updateUserInfo = (data) => post("/home/upUser", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//更新用户信息
export const saveUserVoiceType = (data) => post("/home/saveUserVoiceType", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//发送邮件验证码接口
export const sendEmail = (data) => post("/login/sendEmail", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

//解析获取谷歌用户信息
export const decodeGoogleUserInfo = (data) => post("/login/decodeGoogleUserInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 谷歌邮箱注册接口
export const googleRegister = (data) => post("/login/register", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

//邮箱注册接口
export const loginRegister = (data) => post("/login/register", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

//苹果注册接口
export const appleRegister = (data) => post("/login/registerApple", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})
//谷歌注册接口
export const registerGoogle = (data) => post("/login/registerGoogle", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 未登录获取国家
export const getCountryList = (data) => {
	let list = getCountryInfoList(getLanguage())
	return new Promise((resolve, reject) => {
		resolve(list)
	})
}

// 获取价格列表
export const getPriceListV3 = (data) => post("/home/priceListV3", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 获取价格列表
export const getPriceListV2 = (data) => post("/config/priceListV2", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 获取价格列表
export const familyPriceList = (data) => post("/home/familyPriceList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 下载pdf的页面信息
export const cdTipInfo = (data) => post("/course/cdTipInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 苹果注销
export const appleLogOff = (data) => post("/home/appleLogOff", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 获取api的token
export const realtimeSession = (data) => post("/config/realtimeSession", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 获取价格列表
export const getTextPriceList = (data) => post("/config/textPriceList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取国家老师
export const getTeacherListByCountryId = (data) => post("/login/getTeacherListByCountryId", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取推荐的老师
export const teacherList = (data) => post("/login/teacherList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取老师详情
export const getTeacherDetail = (data) => post("/config/getTeacherInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天
export const chat = (data) => post("/home/chat", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//标记已触发提醒
export const closePayMsgSet = (data) => post("/home/closePayMsgSet", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//下载聊天记录
export const chatDownload = (data) => post("/course/chatDownload", data, false).then(res => {
	return res.data
}).catch(err => {
	// console.log(err)
	throw err
})

//聊天
export const saveSubPopStatus = (data) => post("/home/saveSubPopStatus", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天字数统计
export const chatWordNum = (data) => post("/home/chatWordNum", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天时间统计
export const addOnlineTime = (data) => post("/home/addOnlineTime", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天音频
export const chatVoice = (data) => postAudio("/home/getVoiceByChatId", data, true).then(res => {
	return res
}).catch(err => {
	// console.log(err)
	throw err
})

//聊天音频
export const getVoiceByWordV2 = (data) => post("/home/getVoiceByWordV2", data, true).then(res => {
	return res.data
}).catch(err => {
	// console.log(err)
	throw err
})

//从数据库聊天音频
export const chatVoiceUrl = (data) => post("/home/getVoiceUrlByChatId", data, true).then(res => {
	return res.data
}).catch(err => {
	// console.log(err)
	throw err
})

//语音转文字
export const voiceToText = (data, file) => uploadD("/home/voiceToTextV2", data, "audio_file", file, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//语言翻译
export const translateByChatId = (data) => post("/home/translateByChatId", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//用户发音提示
export const fayinTips = (data) => post("/home/fayinTips", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//用户发音提示
export const fayinPractice = (data) => post("/home/fayinPractice", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//用户发音小手
export const fayinPracticeHand = (data) => post("/home/fayinPracticeHand", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//引导弹窗
export const setNewGuideTip = (data) => post("/home/setNewGuideTip", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const fayinVoiceToText = (data, file) => uploadD("/home/fayinVoiceToText", data, "audio_file", file, false).then(res => {
	return res.data
}).catch(err => {
	console.error(err)
	throw err
})

//用户发音地址
export const getUserVoice = (data) => post("/home/getUserVoice", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//VIP倒计时
export const countdown = (data) => post("/home/countdown", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//VIP倒计时
export const autoShowPayPopupSet = (data) => post("/home/autoShowPayPopupSet", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//实时语音socket
export const getRealtimeLink = (data) => post("/home/getRealtimeLink", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//用户魔术棒
export const autoReply = (data) => post("/home/autoReply", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//单词翻译
export const translateWord = (data) => post("/home/translateWord", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取聊天快捷语
export const chatPrompt = (data) => post("/config/chatPrompt", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天包
export const getVoicePriceList = (data) => post("/config/voicePriceList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//支付订单
export const familyPayOrder = (data) => post("/order/familyPayOrder", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//支付订单
export const payOrder = (data) => post("/order/payOrder", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//支付订单
export const payResultVerify = (data) => post("/order/orderDetail", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//更改套餐
export const upPlan = (data) => post("/order/upPlan", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})


//获取问答支持列表
export const getQuestionSupportList = (data) => post("/config/questionList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//意见反馈
export const feedback = (data) => post("/config/feedback", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//是否可以聊天
export const canChat = (data) => post("/home/canChat", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//自动订阅弹层标记
export const autoSubscribeShowSet = (data) => post("/home/autoSubscribeShowSet", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取老师语种
export const getLangList = (data) => {
	let list = {
		"lang_list": [
			{
				"id": "3",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/AR.png",
				"lang_code": "AR",
				"lang_title": "العربية",
				"icon_name": "AR.png"
			},
			{
				"id": "4",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/AZ.png",
				"lang_code": "AZ",
				"lang_title": "Azərbaycanca",
				"icon_name": "AZ.png"
			},
			{
				"id": "5",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/BG.png",
				"lang_code": "BG",
				"lang_title": "Български",
				"icon_name": "BG.png"
			},
			{
				"id": "77",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/BN.png",
				"lang_code": "BN",
				"lang_title": "বাংলা",
				"icon_name": "BN.png"
			},
			{
				"id": "7",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/BS.png",
				"lang_code": "BS",
				"lang_title": "Bosanski",
				"icon_name": "BS.png"
			},
			{
				"id": "9",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/CS.png",
				"lang_code": "CS",
				"lang_title": "Čeština",
				"icon_name": "CS.png"
			},
			{
				"id": "10",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/CY.png",
				"lang_code": "CY",
				"lang_title": "Cymraeg",
				"icon_name": "CY.png"
			},
			{
				"id": "11",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/DA.png",
				"lang_code": "DA",
				"lang_title": "Dansk",
				"icon_name": "DA.png"
			},
			{
				"id": "12",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/DE.png",
				"lang_code": "DE",
				"lang_title": "Deutsch",
				"icon_name": "DE.png"
			},
			{
				"id": "13",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/EL.png",
				"lang_code": "EL",
				"lang_title": "Ελληνικά",
				"icon_name": "EL.png"
			},
			{
				"id": "72",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/BREN.png",
				"lang_code": "EN",
				"lang_title": "English",
				"icon_name": "BREN.png"
			},
			{
				"id": "14",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/EN.png",
				"lang_code": "EN",
				"lang_title": "English",
				"icon_name": "EN.png"
			},
			{
				"id": "15",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/ES.png",
				"lang_code": "ES",
				"lang_title": "Español",
				"icon_name": "ES.png"
			},
			{
				"id": "16",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/ET.png",
				"lang_code": "ET",
				"lang_title": "Eesti",
				"icon_name": "ET.png"
			},
			{
				"id": "17",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/fa_2025101501.png",
				"lang_code": "FA",
				"lang_title": "فارسی",
				"icon_name": "fa_2025101501.png"
			},
			{
				"id": "18",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/FI.png",
				"lang_code": "FI",
				"lang_title": "Suomi",
				"icon_name": "FI.png"
			},
			{
				"id": "20",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/FR.png",
				"lang_code": "FR",
				"lang_title": "Français",
				"icon_name": "FR.png"
			},
			{
				"id": "24",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/HE.png",
				"lang_code": "HE",
				"lang_title": "עברית",
				"icon_name": "HE.png"
			},
			{
				"id": "25",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/HI.png",
				"lang_code": "HI",
				"lang_title": "हिन्दी",
				"icon_name": "HI.png"
			},
			{
				"id": "26",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/HR.png",
				"lang_code": "HR",
				"lang_title": "Hrvatski",
				"icon_name": "HR.png"
			},
			{
				"id": "28",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/HU.png",
				"lang_code": "HU",
				"lang_title": "Magyar",
				"icon_name": "HU.png"
			},
			{
				"id": "29",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/HY.png",
				"lang_code": "HY",
				"lang_title": "Հայերեն",
				"icon_name": "HY.png"
			},
			{
				"id": "30",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/ID.png",
				"lang_code": "ID",
				"lang_title": "Bahasa Indonesia",
				"icon_name": "ID.png"
			},
			{
				"id": "31",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/IS.png",
				"lang_code": "IS",
				"lang_title": "Íslenska",
				"icon_name": "IS.png"
			},
			{
				"id": "32",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/IT.png",
				"lang_code": "IT",
				"lang_title": "Italiano",
				"icon_name": "IT.png"
			},
			{
				"id": "33",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/JA.png",
				"lang_code": "JA",
				"lang_title": "日本語",
				"icon_name": "JA.png"
			},
			{
				"id": "37",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/KO.png",
				"lang_code": "KO",
				"lang_title": "한국어",
				"icon_name": "KO.png"
			},
			{
				"id": "38",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/LT.png",
				"lang_code": "LT",
				"lang_title": "Lietuvių",
				"icon_name": "LT.png"
			},
			{
				"id": "39",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/LV.png",
				"lang_code": "LV",
				"lang_title": "Latviešu",
				"icon_name": "LV.png"
			},
			{
				"id": "40",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/MK.png",
				"lang_code": "MK",
				"lang_title": "Македонски",
				"icon_name": "MK.png"
			},
			{
				"id": "44",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/MS.png",
				"lang_code": "MS",
				"lang_title": "Bahasa Melayu",
				"icon_name": "MS.png"
			},
			{
				"id": "46",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/NL.png",
				"lang_code": "NL",
				"lang_title": "Nederlands",
				"icon_name": "NL.png"
			},
			{
				"id": "47",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/NO.png",
				"lang_code": "NO",
				"lang_title": "Norsk",
				"icon_name": "NO.png"
			},
			{
				"id": "49",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/PL.png",
				"lang_code": "PL",
				"lang_title": "Polski",
				"icon_name": "PL.png"
			},
			{
				"id": "51",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/PT.png",
				"lang_code": "PT",
				"lang_title": "Português",
				"icon_name": "PT.png"
			},
			{
				"id": "52",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/RO.png",
				"lang_code": "RO",
				"lang_title": "Română",
				"icon_name": "RO.png"
			},
			{
				"id": "53",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/RU.png",
				"lang_code": "RU",
				"lang_title": "Русский",
				"icon_name": "RU.png"
			},
			{
				"id": "55",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/SK.png",
				"lang_code": "SK",
				"lang_title": "Slovenčina",
				"icon_name": "SK.png"
			},
			{
				"id": "56",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/SL.png",
				"lang_code": "SL",
				"lang_title": "Slovenščina",
				"icon_name": "SL.png"
			},
			{
				"id": "59",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/SR.png",
				"lang_code": "SR",
				"lang_title": "Српски",
				"icon_name": "SR.png"
			},
			{
				"id": "60",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/SV.png",
				"lang_code": "SV",
				"lang_title": "Svenska",
				"icon_name": "SV.png"
			},
			{
				"id": "58",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/SQ.png",
				"lang_code": "SQ",
				"lang_title": "Shqip",
				"icon_name": "SQ.png"
			},
			{
				"id": "62",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/TA.png",
				"lang_code": "TA",
				"lang_title": "தமிழ்",
				"icon_name": "TA.png"
			},
			{
				"id": "64",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/TH.png",
				"lang_code": "TH",
				"lang_title": "ไทย",
				"icon_name": "TH.png"
			},
			{
				"id": "65",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/TR.png",
				"lang_code": "TR",
				"lang_title": "Türkçe",
				"icon_name": "TR.png"
			},
			{
				"id": "78",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/UR.png",
				"lang_code": "UR",
				"lang_title": "اردو",
				"icon_name": "UR.png"
			},
			{
				"id": "66",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/UK.png",
				"lang_code": "UK",
				"lang_title": "Українська",
				"icon_name": "UK.png"
			},
			{
				"id": "69",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/VI.png",
				"lang_code": "VI",
				"lang_title": "Tiếng Việt",
				"icon_name": "VI.png"
			},
			{
				"id": "70",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/ZH.png",
				"lang_code": "ZH",
				"lang_title": "中文（简体）",
				"icon_name": "ZH.png"
			},
			{
				"id": "71",
				"icon_url": "https://resource.speakpal.ai/call_images/images/languages/ZH-HANT.png",
				"lang_code": "ZH-HANT",
				"lang_title": "中文（繁體）",
				"icon_name": "ZH-HANT.png"
			}
		]
	}

	return new Promise((resolve, reject) => {
		resolve(list)
	})
}

//获取用户支持的语种
export const getUserLangList = (data) => post("/config/langList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取学习页面的国家详情
export const getLearnLangInfo = (data) => post("/config/countryPageInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})


//获取并更新页面meta信息
export const updateSeoMeta = (path) => post("/config/getSeo", {
	path: path,
	lang_code: path == "learn" ? getLanguage() : ""
}, false).then(res => {
	changeSeoMeta(res.data.title, res.data.keywords, res.data.describe_text)
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取聊天记录
export const getChatList = (data) => post("/home/chatList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取课程页 菜单列表
export const getCourseList = (data) => post("/course/CourseList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取课程的列表
export const getCourseSubject = (data) => post("/course/CourseSubject", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取历史记录
export const getChatRecord = (data) => post("/home/chatRecord", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取历史记录语音
export const getTextToVoice = (data) => post("/course/textToVideo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取练习等级接口
export const getCourseSelect = (data) => post("/config/courseSelect", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//更新用户课程记录
export const setUserCurseUpdate = (data) => post("/course/userCurseUpdate", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天快捷场景的下拉框
export const getSceneList = (data) => post("/config/sceneList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//聊天快捷场景的提示词
export const getScenePrompt = (data) => post("/config/scenePrompt", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//取消选中聊天快捷场景的提示词
export const sceneCancel = (data) => post("/home/sceneCancel", data, false).then(res => {
	return res
}).catch(err => {
	console.log(err)
	throw err
})

//清除小红点
export const clearRedDot = (data) => post("/home/upRead", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//标记语音引导小手
export const setVoiceHand = (data) => post("/home/setVoiceHand", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})


//终身vip信息
export const lifetimeInfo = (data) => post("/home/lifetimeInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//提示升级
export const oneLifetimeInfo = (data) => post("/home/oneLifetimeInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//月费提示升级年费
export const oneMonthUpgradeYear = (data) => post("/home/oneMonthUpgradeYear", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//获取发音注释
export const pronounceByChatId = (data) => post("/home/pronounceByChatId", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 证书弹窗
export const tipInfo = (data) => post("/certificate/tipInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//证书完成标记接口
export const completeMark = (data) => post("/certificate/completeMark", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 生成证书
export const generate = (data) => post("/certificate/generate", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 下载证书
export const certDownload = (data) => post("/certificate/download", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 推特登录
export const getTwitterAuthorize = (data) => post("/login/twitter", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 推特登录
export const setRegisterTwitter = (data) => post("/login/registerTwitter", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//分享历史记录
export const getChatRecordShare = (data) => post("/config/shareChatRecord", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 加密userId
export const encodeUserId = (data) => post("/home/encodeUserId", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 下载练习pdf
export const getCourseDownload = (data) => post("/course/CourseDownload", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})


//分享记录聊天音频
export const chatBascourseVoice = (data) => postAudio("/bascourse/getVoiceByChatId", data, true).then(res => {
	return res
}).catch(err => {
	// console.log(err)
	throw err
})

//老师是否需要监测长时间在线提醒
export const getTeacherOnlineRemind = (data) => post("/home/remindIs", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//标记老师已提醒
export const setTeacherOnlineRemind = (data) => post("/home/remindSet", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 删除记录
export const getDelRecord = (data) => post("/home/chatDel", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//清空记录
export const chatClear = (data) => post("/home/chatClear", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//邮箱进入的用户埋点
export const getEmailEnter = (data) => post("/bascourse/clickEmail", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//退订邮箱
export const unsubscribeEmail = (data) => post("/bascourse/addEmailBlack", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

//青少年模式的密码验证
export const getTeenagerVerify = (data) => post("/home/checkAdolescentPassword", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const getUserRankList = (data) => post("/config/userRankList", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const resetPassword = (data) => post("/login/resetPassword", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

// 机构信息 
export const organizationInfo = (data) => post("/organization/info", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const organizationUserList = (data) => post("/organization/userList", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const organizationAddUser = (data) => post("/organization/addUser", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息
export const organizationDelUser = (data) => post("/organization/delUser", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 学生状态修改接口
export const statUser = (data) => post("/organization/statUser", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const organizationUploadLogoTitle = (data) => post("/organization/uploadLogoTitle", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const organizationSaveLogoLink = (data) => post("/organization/saveLogoLink", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

//机构logo
export const organizationUploadLogoPic = (data, file) => uploadD("/organization/uploadLogoPic", data, "file", file, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const organizationStatInfo = (data) => post("/organization/statInfo", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const organizationOverUserList = (data) => post("/organization/overUserList", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const organizationDelLogoPic = (data) => post("/organization/delLogoPic", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const organizationReport = (data) => post("/organization/report", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})

export const getOrgInfo = (data) => post("/config/getOrgInfo", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log(err)
	throw err
})


// 家庭信息
export const familyInfo = (data) => post("/organization/familyInfo", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const familyUserList = (data) => post("/organization/familyUserList", data, true).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const familyAddUser = (data) => post("/organization/familyAddUser", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const familyDelUser = (data) => post("/organization/familyDelUser", data, false).then(res => {
	return res.data
}).catch(err => {
	console.log("regist error", err)
	throw err
})

// 机构信息 
export const changePageColor = (data) => post("/organization/changePageColor", data, true).then(res => {
	return res.data
}).catch(err => {
	throw err
})